import script from "./MemberBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberBanner.vue?vue&type=script&lang=ts&setup=true"

import "./MemberBanner.vue?vue&type=style&index=0&id=5ef13121&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef13121"]])

export default __exports__